import { render } from "./CallerAuthentication.vue?vue&type=template&id=28d80a98&ts=true"
import script from "./CallerAuthentication.vue?vue&type=script&lang=ts"
export * from "./CallerAuthentication.vue?vue&type=script&lang=ts"

import "./CallerAuthentication.vue?vue&type=style&index=0&id=28d80a98&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__